(function () {
    "use strict";

    angular
        .module("expedientesUriarteApp")
        .controller("LebaniegoYearContactosSectorOsNewController", LebaniegoYearContactosSectorOsNewController);

    LebaniegoYearContactosSectorOsNewController.$inject = [
        "$rootScope",
        "$timeout",
        "$scope",
        "entity",
        "LebaniegoYearContactosSectorOs",
        "$state",
        "previousState",
        "toastr",
        "DateUtils",
        "$mdSidenav",
    ]

    function LebaniegoYearContactosSectorOsNewController(
        $rootScope,
        $timeout,
        $scope,
        entity,
        LebaniegoYearContactosSectorOs,
        $state,
        previousState,
        toastr,
        DateUtils,
        $mdSidenav
    ) {
        var vm = this;

        vm.lebaniegoYearContactosSectorOs = entity;
        vm.clear = clear;
        vm.save = save;
        vm.toggleSidenav = buildToggler("left");

        $timeout(function () {
            angular.element(".form-group:eq(1)>input").focus();
        });

        function clear() {
            $state.go(previousState.name, previousState.params);
        }

        function save() {
            vm.isSaving = true;
            var lebaniegoYearContactosSectorOs = Object.assign({}, vm.lebaniegoYearContactosSectorOs);
            lebaniegoYearContactosSectorOs.id = null;
            lebaniegoYearContactosSectorOs.sector = "Otros sectores";
            LebaniegoYearContactosSectorOs.save(lebaniegoYearContactosSectorOs, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            toastr.success("Creada con éxito!");
            vm.isSaving = false;
            $state.go("lebaniego-contacts-sector-os", {});
        }

        function onSaveError() {
            toastr.error("Error al crear el acta");
            vm.isSaving = false;
        }

        function buildToggler(navID) {
            return function () {
                $mdSidenav(navID).toggle().then(function () {});
            }
        }
    }
})();